/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfEntitiesDto } from "../models/AjaxResponseOfEntitiesDto";
import type { AjaxResponseOfEntityCreateDto } from "../models/AjaxResponseOfEntityCreateDto";
import type { AjaxResponseOfInt64 } from "../models/AjaxResponseOfInt64";
import type { AjaxResponseOfPagedResultDtoOfGetEntityForViewDto } from "../models/AjaxResponseOfPagedResultDtoOfGetEntityForViewDto";
import type { EntityCreateDto } from "../models/EntityCreateDto";
import type { EntityType } from "../models/EntityType";
import type { EntityUpdateDto } from "../models/EntityUpdateDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class EntityAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfPagedResultDtoOfGetEntityForViewDto
   * @throws ApiError
   */
  public getAll({
    filter,
    entityTypeFilter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    entityTypeFilter?: EntityType;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfGetEntityForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entities",
      query: {
        filter: filter,
        entityTypeFilter: entityTypeFilter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfInt64
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: EntityCreateDto;
  }): CancelablePromise<AjaxResponseOfInt64> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/entities",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: EntityUpdateDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/entities",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfEntitiesDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfEntitiesDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entities/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/entities/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfEntityCreateDto
   * @throws ApiError
   */
  public getCreatDtoByCpf({
    cpf,
  }: {
    cpf: string;
  }): CancelablePromise<AjaxResponseOfEntityCreateDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entities/pf/{cpf}",
      path: {
        cpf: cpf,
      },
    });
  }

  /**
   * @returns AjaxResponseOfEntityCreateDto
   * @throws ApiError
   */
  public getCreatDtoByCnpj({
    cnpj,
  }: {
    cnpj: string;
  }): CancelablePromise<AjaxResponseOfEntityCreateDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/entities/pj/{cnpj}",
      path: {
        cnpj: cnpj,
      },
    });
  }
}
